export default __webpack_public_path__ + "static/media/WStore_Icon_Bethlehem.9a560f8c.png";